import { Box, Button, Flex } from "@chakra-ui/react";
import MyEvaluationChoices from "./MyEvaluationChoices";
import MyEvaluationQuestion from "./MyEvaluationQuestion";
import MyEvaluationNavigationButtons from "./MyEvaluationNavigationButtons";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { useContext, useState } from "react";
import { EvaluationContext } from "./MyEvaluationContext";
import { llmCorrectMultipleQuestion } from "service/LlmServices";
import { t } from "i18next";

const MyEvaluationMultipleChoice = () => {
  const [loading, setLoading] = useState(false);
  const {
    evaluationQuestionTitle,
    evaluation,
    correctAnswers,
    evaluationNumber,
    setChoicesFeedback,
    updateCorrectAnswers,
  } = useContext(EvaluationContext);
  const suggestCorrectionMultipleQuestion = async () => {
    try {
      setLoading(true);
      const response = await llmCorrectMultipleQuestion({
        title: evaluationQuestionTitle,
        possible_choices: evaluation.possible_choices,
        correct_answer: correctAnswers,
        form_title: evaluationNumber,
        use_llm_to_determine_correctness: true,
      });
      setChoicesFeedback(response.choices_feedback);
      if (response.correct_answers_determined.length)
        updateCorrectAnswers(
          response.correct_answers_determined
            .map((item) => {
              return evaluation.possible_choices.findIndex(
                (choice) => item === choice
              );
            })
            .filter((item) => item !== -1)
        );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <Box width="100%">
      <Flex align={"center"}>
        <MyEvaluationQuestion />
        <Button
          onClick={() => {
            suggestCorrectionMultipleQuestion();
          }}
          isLoading={loading}
          marginLeft={"auto"}
          marginBottom={6}
          rightIcon={<FaWandMagicSparkles />}
        >
          {t("CORRECT_WITH_IA")}
        </Button>
      </Flex>
      <MyEvaluationChoices />
      <MyEvaluationNavigationButtons />
    </Box>
  );
};

export default MyEvaluationMultipleChoice;
